export { FALABELLA_ENABLED_COUNTRIES, isFalabellaEnabledCountry } from '@/constants/falabella';

export const falabellaStatusOptions = [
  { value: 'pending', label: 'Pendiente' },
  { value: 'ready_to_ship', label: 'Listo para envío' },
  { value: 'shipped', label: 'Enviado' },
  { value: 'delivered', label: 'Entregado' },
  { value: 'returned', label: 'Devuelto' },
  { value: 'canceled', label: 'Cancelado' },
];

export const falabellaModalityOptions = [
  { value: 'direct', label: 'Direct' },
  { value: 'regular', label: 'Regular' },
  { value: 'nextday', label: 'Next Day' },
  { value: 'clickandcollect', label: 'Click & Collect' },
];

export const getFalabellaStatusLabel = (status?: string): string => {
  switch (status?.toLowerCase()) {
    case 'pending':
      return 'Pendiente';
    case 'ready_to_ship':
      return 'Listo para envío';
    case 'shipped':
      return 'Enviado';
    case 'delivered':
      return 'Entregado';
    case 'returned':
    case 'return':
      return 'Devuelto';
    case 'canceled':
    case 'cancelled':
      return 'Cancelado';
    case 'failed':
      return 'Fallido';
    default:
      return status || '-';
  }
};

export const getFalabellaStatusBg = (status?: string): string => {
  switch (status?.toLowerCase()) {
    case 'pending':
      return '#FFF9E6';
    case 'ready_to_ship':
      return '#E3F2FD';
    case 'shipped':
      return '#D6F2DF';
    case 'delivered':
      return '#C8E6C9';
    case 'returned':
    case 'return':
      return '#E8DAEF';
    case 'canceled':
    case 'cancelled':
      return '#F6DDDC';
    case 'failed':
      return '#F8D7DA';
    default:
      return '#F5F5F5';
  }
};

export const getFalabellaStatusColor = (status?: string): string => {
  switch (status?.toLowerCase()) {
    case 'pending':
      return '#F39C12';
    case 'ready_to_ship':
      return '#1565C0';
    case 'shipped':
      return '#27AE60';
    case 'delivered':
      return '#1B5E20';
    case 'returned':
    case 'return':
      return '#8E44AD';
    case 'canceled':
    case 'cancelled':
      return '#C0392B';
    case 'failed':
      return '#E74C3C';
    default:
      return '#616161';
  }
};

export const get99mStatusLabel = (status?: string): string => {
  switch (status?.toLowerCase()) {
    case 'created':
      return 'Creada';
    case 'pending':
      return 'Pendiente';
    case 'delivered':
      return 'Entregada';
    case 'returned':
    case 'return':
      return 'Devuelta';
    case 'canceled':
    case 'cancelled':
      return 'Cancelada';
    case 'failed':
    case 'error':
      return 'Error';
    default:
      return status || '-';
  }
};

export const get99mStatusBg = (status?: string): string => {
  switch (status?.toLowerCase()) {
    case 'created':
      return '#D6F2DF';
    case 'pending':
      return '#FFF9E6';
    case 'delivered':
      return '#C8E6C9';
    case 'returned':
    case 'return':
      return '#E8DAEF';
    case 'canceled':
    case 'cancelled':
      return '#F6DDDC';
    case 'failed':
    case 'error':
      return '#F8D7DA';
    default:
      return '#F5F5F5';
  }
};

export const get99mStatusColor = (status?: string): string => {
  switch (status?.toLowerCase()) {
    case 'created':
      return '#27AE60';
    case 'pending':
      return '#F39C12';
    case 'delivered':
      return '#1B5E20';
    case 'returned':
    case 'return':
      return '#8E44AD';
    case 'canceled':
    case 'cancelled':
      return '#C0392B';
    case 'failed':
    case 'error':
      return '#E74C3C';
    default:
      return '#616161';
  }
};

export const getFalabellaModalityLabel = (modality?: string): string => {
  const clean = (modality || '').toLowerCase().trim();
  switch (clean) {
    case 'direct':
      return 'Direct';
    case 'regular':
      return 'Regular';
    case 'nextday':
      return 'Next Day';
    case 'clickandcollect':
      return 'Click & Collect';
    default:
      return modality ? modality.charAt(0).toUpperCase() + modality.slice(1) : 'Regular';
  }
};
